export default __webpack_public_path__ + "static/lp-men-hero-desktop-8d926193bdd01cfe8c01ee00999efafb.webp";